const SitemapIndex = {
  /**
   * Create SitemapIndex component
   * @param {HTMLElement} node
   * @return {Void}
   */
  create(node) {
    this.submitButton = node.querySelector('button');

    this.submitButton.addEventListener('click', () => {
      this.submitSitemap(node.querySelector('input').value.trim());
      this.submitButton.setAttribute('disabled', 'disabled');
    });
  },

  /**
   * Submit sitemap to the search engines using our API
   * @param {String} url
   * @return {void}
   */
  submitSitemap(url) {
    window.axios.post('/admin/sitemap/ping', {
      url,
    })
      .then(() => {
        window.toaster.show('De sitemap is verzonden naar de zoekmachines', 4000);
      })
      .catch(() => {
        window.toaster.show('Er ging iets mis bij het pingen naar de zoekmachines', 4000, 'danger');
        this.submitButton.removeAttribute('disabled');
      });
  },
};

export default SitemapIndex;
